import MasonryVideo from '../components/MasonryVideo';

export default class DynamicMasonry {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    this.masonryVideo = null;
    this.urls = $('[data-masonry-url]', this.$el);
    this.videos = $('[data-masonry-video]', this.$el);

    this._redirectMasonryFeatures = this._redirectMasonryFeatures.bind(this);
    this._masonryVideo = this._masonryVideo.bind(this);

    this._bindEvents();
  }

  _bindEvents() {
    this.urls.on('click', event => this._redirectMasonryFeatures(event));
    this.videos.on('click', event => this._masonryVideo(event));
  }

  onSectionUnload() {
    if (this.masonryVideo != null) {
      this.masonryVideo.remove();
    }
    this.urls.off('click');
    this.videos.off('click');
  }

  _redirectMasonryFeatures(e) {
    const $target = $(e.currentTarget);

    if (!$target.parents(this.$masonry).length) return;

    const url = $target.data('masonry-url');

    if (url !== '') {
      window.location = url;
    }
  }

  _masonryVideo(event) {
    this.masonryVideo = new MasonryVideo(this.$el, event);
  }
}
